import { limitOrderFormApiConnector } from 'apiConnector/secondary-market/limit-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function fetchLimitOrderInteractionClientEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { interactClient } = limitOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_CLIENT_RELATED_FETCH_REQUESTED'),
      mergeMap(({ tabId, request }) => {
        return interactClient(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => limitOrderThunks.linkedToClientReceivedThunk(tabId, data)),
          catchError((err: Error) => {
            return of(limitOrderInputFormActions.clientRequestFailed(tabId, err.message));
          }),
        );
      }),
    );
  };
}
